import {Command} from 'substance'
import {Event} from '../../../lib/constants/Event'

class ReadModeCommand extends Command {
    getCommandState() {
        return true
    }

    execute(params) {
        const {api} = params
        const namespace = 'se.infomaker.readmode.settings'
        const key = 'active'

        const value = !(api.settings.get(namespace, key, false))

        api.settings.set(namespace, key, value)

        setTimeout(() => {
            api.events.trigger(
                null,
                Event.SETTINGS_CHANGED,
                {
                    key: `${namespace}.${key}`,
                    value: value
                }
            )
        }, 10)
    }
}

export default ReadModeCommand
